import { RouteObject } from 'react-router-dom';
import HelpArticleListPage from '@/pages/help/HelpArticleListPage';
import HelpArticleDetailPage from '@/pages/help/HelpArticleDetailPage';

export const helpArticleRoutes: RouteObject[] = [
  {
    path: '/help-articles',
    children: [
      {
        index: true,
        element: <HelpArticleListPage />,
      },
      {
        path: ':id',
        element: <HelpArticleDetailPage />,
      },
    ],
  },
];
